import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <header className="header">
      <div className="logo">
        <img src="/sertiva_logo.png" alt="SERTIVA Logo" />
      </div>
      <nav className={isOpen ? "nav-open" : ""}>
        <ul>
          <li><Link to="/" onClick={toggleMenu}>Home</Link></li>
          <li><Link to="/about" onClick={toggleMenu}>About</Link></li>
          <li><Link to="/projects" onClick={toggleMenu}>Projects</Link></li>
          <li><Link to="/contact" onClick={toggleMenu}>Contact</Link></li>
        </ul>
      </nav>
      <div className="burger" onClick={toggleMenu}>
        <div className={isOpen ? "line line1-open" : "line line1"}></div>
        <div className={isOpen ? "line line2-open" : "line line2"}></div>
        <div className={isOpen ? "line line3-open" : "line line3"}></div>
      </div>
    </header>
  );
};

export default Header;
